export {
  OnboardingQuestionSkipButton,
  OnboardingQuestionSkipButtonProps,
} from './OnboardingQuestionSkipButton';
